/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { SAVE_TRACK_RETURN, SAVE_VALIDATION_DATA} from './constants';

// The initial state of the App
export const initialState = {
  trackReturn:[],
  validatonData:[],
};


/* eslint-disable default-case, no-param-reassign */
const gstinFilingReducer = (state = initialState, action) =>{
    switch (action.type) {
      
    case SAVE_TRACK_RETURN:
        return {
        ...state,
        trackReturn:action.data
        }

        case SAVE_VALIDATION_DATA:
        console.log("validatonData:",action.data)
        return {
            ...state,
            validatonData:action.data
        }
        
        default:
        return state; 
    }
  };

export default gstinFilingReducer;
